import { render } from "./AddCredentialModal.vue?vue&type=template&id=6a18f194"
import script from "./AddCredentialModal.vue?vue&type=script&lang=js"
export * from "./AddCredentialModal.vue?vue&type=script&lang=js"

import "./AddCredentialModal.vue?vue&type=style&index=0&id=6a18f194&lang=css"
script.render = render

export default script